import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from './AuthContext';
import './Sidebar.css';

interface SidebarProps {
  isOpen: boolean;
  closeSidebar: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen, closeSidebar }) => {
  const { user, logout } = useAuth();

  const handleLinkClick = () => {
    if (window.innerWidth <= 768) {
      closeSidebar();
    }
  };

  return (
    <div className={`sidebar ${isOpen ? 'open' : ''}`}>
      <div className="sidebar-header">
        <h2>VKS TRADERS</h2>
      </div>
      <nav className="sidebar-nav">
        <NavLink to="/dashboard" end className={({ isActive }) => "nav-link" + (isActive ? " active" : "")} onClick={handleLinkClick}>
          Dashboard
        </NavLink>
        <NavLink to="/add-member" className={({ isActive }) => "nav-link" + (isActive ? " active" : "")} onClick={handleLinkClick}>
          Add Member
        </NavLink>
        <NavLink to="/members" className={({ isActive }) => "nav-link" + (isActive ? " active" : "")} onClick={handleLinkClick}>
          Members List
        </NavLink>
        <NavLink to="/profile" className={({ isActive }) => "nav-link" + (isActive ? " active" : "")} onClick={handleLinkClick}>
          My Profile
        </NavLink>
        <NavLink to="/wallet" className={({ isActive }) => "nav-link" + (isActive ? " active" : "")} onClick={handleLinkClick}>
          Wallet
        </NavLink>
        <NavLink to="/plan-details" className={({ isActive }) => "nav-link" + (isActive ? " active" : "")} onClick={handleLinkClick}>
          Plan Details
        </NavLink>
        {user?.role === 'admin' && (
          <>
            <hr style={{ borderColor: '#34495e', margin: '10px 20px' }} />
            <NavLink to="/admin/users" className={({ isActive }) => "nav-link" + (isActive ? " active" : "")} onClick={handleLinkClick}>
              User Management
            </NavLink>
            <NavLink to="/admin/transactions" className={({ isActive }) => "nav-link" + (isActive ? " active" : "")} onClick={handleLinkClick}>
              Fund Management
            </NavLink>
          </>
        )}
      </nav>
      <div className="sidebar-footer">
        <div className="user-info">
            <span>{user?.username}</span>
            <small>{user?.role}</small>
        </div>

        <button onClick={logout} className="logout-button-sidebar">
          Log Out
        </button>
      </div>
    </div>
  );
};

export default Sidebar;